<template>
  <div>
    <div class='scale-spinner spinnerDelay1' />
    <div class='scale-spinner spinnerDelay2' />
    <div class='scale-spinner spinnerDelay3' />
    <div class='scale-spinner spinnerDelay4' />
    <div class='scale-spinner spinnerDelay5' />
  </div>
</template>

<script>
export default {
  name: 'ScaleSpinner',
  props: {
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/loaders/ScaleSpinner.vue